// Turning API error bodies into sentences people can act on.

/** The organizations service's message when a team's size limit is reached. */
const TEAM_FULL = /maximum capacity/i;

const rawMessage = (err: unknown): string | undefined => {
  const data = (err as { response?: { data?: { error?: string; message?: string } } })?.response?.data;
  return data?.error || data?.message || undefined;
};

/**
 * The server's message, or `fallback`. A full team gets wording for who is
 * reading: an admin can raise the limit; a member has to ask an admin.
 */
export function apiErrorMessage(err: unknown, fallback: string, reader: 'admin' | 'member' = 'admin'): string {
  const raw = rawMessage(err);
  if (raw && TEAM_FULL.test(raw)) {
    return reader === 'admin'
      ? 'That team is full. Raise its size limit on Teams, then try again.'
      : 'That team is full right now. Ask your church admin to make room, then try the code again.';
  }
  return raw || fallback;
}

/** True when an axios or fetch error is an authorization failure (401 or 403). */
export function isForbiddenError(err: unknown): boolean {
  const e = err as { response?: { status?: number }; status?: number } | null | undefined;
  const status = e?.response?.status ?? e?.status;
  return status === 401 || status === 403;
}
